// removed by extract-text-webpack-plugin
module.exports = {"button":"_3TGKcxB"};


//////////////////
// WEBPACK FOOTER
// ./template/components/IconButton/index.css
// module id = ./template/components/IconButton/index.css
// module chunks = client.sitechrome